export default [
  {
    img: "/products/ready-env-print.png",
    title: { en: "Print on envelope", uk: "Друк по готових конвертах" },
    text: {
      en:
        "This is a convenient way to print on envelopes, but printing on the entire area and on the edges is impossible - the machine needs a gap of 5-10 mm. Maximum colors - 4.",
      uk:
        "Це зручний спосіб нанесення друку на конверти, однак друк на всій площі і по краях неможливий — машині потрібен відступ 5-10 мм. Максимальна кількість кольорів - 4.",
    },
    id: "printReadyEnv",
  },
  {
    img: "/products/print-vukroi.png",
    title: { en: "Print on carved", uk: "Друк на викроях" },
    text: {
      en:
        "First, print is applied to sheets of paper, after that press cut them, then machine makes it into an envelope. Maximun colors - 6 on the outside and inside.",
      uk:
        "Спочатку друк наноситься на листи паперу, потім пресом висікаються викрої, далі машина згортає їх в конверт. Максимальна кількість кольорів - 6 з зовнішньої та внутрішньої сторін.",
    },
    id: "printCutoutEnv",
  },
  {
    img: "/products/digital-print.png",
    title: { en: "Digital print", uk: "Цифровий друк" },
    text: {
      en:
        "It is a fast way of full color printing on paper bags, banderole bags and other products, which can't be offset printed.",
      uk:
        "Це швидкий спосіб повноколірного друку на паперових торбах, бандерольних пакетах та інших виробах, які не можна задрукувати офсетним друком.",
    },
    id: "printDigital",
  },
]
